<template>
  <v-dialog v-model="openDialog" persistent max-width="800px">
    <v-card color="accent">
      <v-card-title class="pl-6 pt-4">
        <v-icon class="mr-2" color="error">mdi-alert</v-icon>
        <span class="text-h5">Buchung stornieren</span>
      </v-card-title>
      <v-card-text class="py-0">
        <span class="text-h6">
          Sind Sie sicher, dass Sie die Buchung
          <strong>{{ toReject.id }}</strong> stornieren wollen?
        </span>
      </v-card-text>
      <v-card-text>
        <v-textarea
          variant="outlined"
          v-model="rejectReason"
          label="Begründung der Stornierung"
          placeholder="Aus welchem Grund wird die Stornierung durchgeführt?"
          rows="2"
        ></v-textarea>
      </v-card-text>
      <v-card-actions class="mr-4 mb-2">
        <v-spacer />
        <v-btn variant="elevated" color="primary" :loading="inProgress" @click="onReject"
          >Ja</v-btn
        >
        <v-btn class="ml-3" variant="outlined" @click="closeDialog">Nein</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiBookingService from "@/services/api/ApiBookingService";
import Matomo from "@/utils/Matomo";
import { mapGetters } from "vuex";

export default {
  name: "BookingDeleteConformationDialog",
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    toReject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      inProgress: false,
      rejectReason: null,
    };
  },
  computed: {
    ...mapGetters({
      tenantId: "tenants/currentTenantId",
    }),
    openDialog: {
      get() {
        return this.open;
      },
    },
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    async onReject() {
      this.inProgress = true;
      try {
        await ApiBookingService.rejectBooking(
          this.toReject.id,
          this.tenantId,
          this.rejectReason
        );
        Matomo.trackEvent([
          "trackEvent",
          "Booking",
          "Rejected (Single)",
          this.toReject?.id,
          1,
        ]);
        this.closeDialog();
      } catch (err) {
        console.error(err);
      } finally {
        this.inProgress = false;
      }
    },
  },
};
</script>

<style scoped></style>
